import { CloseCircle } from 'entities/close-circle/model'

import { InsuranceCitizenship } from '../../../../../model/types'

export const getCloseCirclePersonData = (closeCircle: CloseCircle) => ({
  lastName: closeCircle.last_name,
  firstName: closeCircle.first_name,
  birthDate: closeCircle.date_of_birth,
  passportNumber: closeCircle.document_number,
})

export const getCloseCircleCitizenship = (
  closeCircle: CloseCircle,
  citizenships: InsuranceCitizenship[],
): InsuranceCitizenship | undefined => {
  const names = [closeCircle.citizenship_obj?.country, closeCircle.citizenship]
    .filter((name): name is string => Boolean(name))
    .map((name) => name.trim().toLocaleLowerCase())

  return citizenships.find(({ name }) =>
    names.includes(name.trim().toLocaleLowerCase()),
  )
}
